import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar'; 
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import { GithubIcon } from '../icons/index';
import { withTheme } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Avatar from 'material-ui/Avatar';
import axios from 'axios';
import CSV from 'csv-string';
import {TableSimple, MaterialTable} from './Table';
import Paper from 'material-ui/Paper';
import { Parallax, Background } from 'react-parallax';
import GridList, { GridListTile, GridListTileBar } from 'material-ui/GridList';

const bigAvatar = {
    width: "130px",
    height: "130px",
    margin: "auto",
};

const scheduleURL = "https://docs.google.com/spreadsheets/d/1vpscmJspS2H4tptfwhKwWJRNBwPTAQEfsx2hORqbIUY/export?format=csv";

const classImages = [
    {
        url: 'http://suyashkumar.com/img/class/Brainstorming02.jpg',
        caption: 'In-class brainstorming',
    },
    {
        url: 'http://suyashkumar.com/img/class/mel_app_4.png',
        caption: "Melanoma detector"
    },
    {
        url: 'http://suyashkumar.com/img/class/Lecture01.jpg',
        caption: 'Cloud-based melanoma detection design'
    },
    {
        url: 'http://suyashkumar.com/img/class/TwinniesOfficeHours02.jpg',
        caption: 'Suyash\'s office hours',
    },
    {
        url: 'http://suyashkumar.com/img/class/mel_app_2.png',
        caption: "Melanoma detector"
    },
];

class Home extends Component {
    state = {
        scheduleData: [],
    };
    componentWillMount() {
        axios.get(scheduleURL, {responseType: 'blob'}).then( res => {
            const fr = new FileReader();
            fr.onloadend = e => {
               const text = e.target.result;
               const arr = CSV.parse(text);
               console.log(arr);
               this.setState({scheduleData: arr});

            };
            fr.readAsText(res.data);
        });
    }
  render() {
    return (
      <div>
          <AppBar>
            <Toolbar>
            <Typography
                type="title" color="inherit">
                Medical Software Design
            </Typography>
            <a
                href="https://github.com/mlp6/Medical-Software-Design"
                target="_blank"
                style={{position: 'absolute', right: '15px'}}>
                <IconButton>
                    <GithubIcon />
                </IconButton>
            </a>
            </Toolbar>
          </AppBar>
          <Parallax
              blur={15}
              bgImage={'http://suyashkumar.com/docs/ecg_blue_3.jpg'}
              strength={300}
          >
          <div style={{
              minHeight: '400px',
              padding: '100px 10px 20px 10px',
              textAlign: 'center',
              // backgroundColor: this.props.theme.palette.primary.main1,
              // backgroundImage: 'url(http://suyashkumar.com/docs/ecg_1.jpg)',
              // backgroundRepeat: 'no-repeat',
              // backgroundSize: '100%'
          }}>
              <Typography
                  type="headline"
                  style={{textAlign: 'center', color: '#FFF', fontSize: '30px'}}>
                  BME590: Medical Software Design at Duke University
              </Typography>
              <Typography
                type="subheading"
                style={{color: '#FFF', margin: '25px'}}>
                  by
              </Typography>
              <div>
                  <div
                      style={{textAlign: "center", display: "inline-block", minWidth: "170px", margin: "10px", cursor: "pointer"}}
                      onClick={() => window.open('https://bme.duke.edu/faculty/mark-palmeri')}>
                      <Avatar src="https://avatars2.githubusercontent.com/u/3239175?s=460&v=4" style={bigAvatar}/>
                      <Typography
                          type="subheading"
                          style={{color: '#FFF', marginTop: "10px"}}>
                          Mark Palmeri M.D, Ph.D
                      </Typography>
                  </div>
                  <div
                      style={{textAlign: "center", display: "inline-block", minWidth: "170px", margin: "10px", cursor: 'pointer'}}
                      onClick={() => window.open('http://suyashkumar.com')}>
                      <Avatar src="https://avatars0.githubusercontent.com/u/6299853?s=460&v=4" style={bigAvatar}/>
                      <Typography
                          type="subheading"
                          style={{color: '#FFF', marginTop: "10px"}}>
                          Suyash Kumar
                      </Typography>
                  </div>

              </div>
              <div style={{marginTop: '25px', paddingBottom: "10px"}}>
                <Button raised href="https://github.com/mlp6/Medical-Software-Design/raw/master/Syllabus/syllabus.pdf">
                    S18 Syllabus
                </Button>
              </div>
          </div>
          </Parallax>

          <div style={{backgroundColor: this.props.theme.palette.primary.main2}}>
              <div style={{
                  color: "#FFF",
                  textAlign: "center",
                  padding: "15px",
                  maxWidth: "800px",
                  margin: "auto"
              }}>
                  <Typography
                    type="title"
                    color="inherit">
                     Course Overview
                  </Typography>

                  <Typography
                      type="body1"
                      paragraph={true}
                      style={{color: '#FFF', textAlign: 'justify' }}>
                      <p>
                          This course focuses on software design skills that are ubiquitous in the medical device industry,
                          including software version control, unit testing, fault tolerance, containerization, continuous
                          integration testing and documentation.
                      </p>
                      <p>
                          Given the prevalance of cloud-based systems in modern software and medicine, students will also
                          learn how to build and deploy industry-standard cloud-based web applications.
                          Experience will be gained using technologies like Flask, ReactJS, Docker, MySQL, and more to
                          build applications like a cloud-based ECG analysis service.
                      </p>
                      <p>
                          This class requires students to complete a final project that ties together the technologies,
                          methodologies, and skills taught in this class. In previous semesters students have built
                          everything from cloud-based melanoma detection applications to cervical cancer detection
                          applications.
                      </p>
                  </Typography>
                  <GridList
                      cols={2.2}
                      style={
                          {flexWrap: 'nowrap'}
                      }
                      cellHeight={200} >
                      {
                          classImages.map(tile => (
                              <GridListTile>
                                  <img src={tile.url} />
                                  <GridListTileBar
                                        title={tile.caption}
                                        style={{background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)'}}>
                                  </GridListTileBar>
                              </GridListTile>
                          ))
                      }
                  </GridList>
              </div>
          </div>

          <div style={{padding: "15px"}}>
              <Typography
                  type="title"
                  color="inherit"
                  style={{textAlign: "center"}}>
                  S18 Schedule
              </Typography>
              <Paper style={{margin: 'auto', marginTop: '20px', maxWidth: '800px'}}>
                <MaterialTable data={this.state.scheduleData} />
              </Paper>

          </div>
      </div>

    );
  }
}

export default withTheme()(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js